<template>
  <div class="p-2 md:p-2">
    <div class="mx-0 md:mx-4 p-2">
      <div class="flex items-center">
        <div class="flex items-center" v-for="(item,index) in items" :key="index"
             :class="index<items.length-1? 'w-full':''">
          <div class="flex items-center relative"
               :class="value? item.codigo<=value? activeClass.icon_color:normalClass.icon_color:item.isActive?activeClass.icon_color:normalClass.icon_color">
            <div class="rounded-full transition duration-500 ease-in-out h-10 w-10 py-2 border-2 text-center"
                 :class="value? item.codigo<=value? activeClass.boder_color +' '+ activeClass.bg_color:normalClass.boder_color +' '+ normalClass.bg_color: item.isActive? activeClass.boder_color +' '+ activeClass.bg_color : normalClass.boder_color +' '+ normalClass.bg_color ">
              <p>{{ item.codigo }}</p>
            </div>
            <div
                class="absolute top-0 -left-10 text-center mt-12 w-32 text-xs font-medium px-5"
                :class="value ? item.codigo<=value?activeClass.text_color:normalClass.text_color: item.isActive? activeClass.text_color: normalClass.text_color">
              {{ item.name }}
            </div>
          </div>
          <div class="border-2 border-t flex-auto"
               :class="value ? item.codigo<=value? activeClass.line_color:normalClass.line_color: item.isActive?activeClass.line_color: normalClass.line_color"
               v-if="index<items.length-1"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "stepper",
  props: {
    value: null,
    activeClass: {
      type: Object,
      default: {
        text_color: 'text-gob',
        icon_color: 'text-white',
        boder_color: 'border-gob',
        bg_color: 'bg-gob',
        line_color: 'bg-gray-500'
      }
    },
    normalClass: {
      type: Object,
      default: {
        text_color: 'text-blue-500',
        boder_color: 'border-blue-500',
        bg_color: '',
        icon_color: 'text-blue-500',
        line_color: 'bg-gray-500'
      }
    },
    items: {
      required: true,
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>